import * as React from 'react'
import {
  DialogTitle as MuiDialogTitle,
  IconButton,
  Close as CloseIcon,
  Typography,
  withStyles,
  WithStyles,
} from '@zn-material-ui'

import dialogTitleStyles from './DialogTitleStyle'

interface IProps extends WithStyles<typeof dialogTitleStyles> {
  children?: any
  onClose: () => void
}

const DialogTitle = (props: IProps) => {
  const { children, classes, onClose } = props
  return (
    <MuiDialogTitle disableTypography={true} className={classes.root}>
      {children && <Typography variant="h6">{children}</Typography>}
      {onClose && (
        <IconButton
          aria-label="Close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      )}
    </MuiDialogTitle>
  )
}

export default withStyles(dialogTitleStyles)(DialogTitle)
